import { type GraphDataError } from './graphs';
import type { Units } from './units';

export type TideLocation = {
  lat: number;
  lon: number;
  max: number;
  mean: number;
  min: number;
  name: string;
};

export type TideLevel = 'LOW' | 'HIGH' | 'NORMAL';

export interface TidePoint {
  type: TideLevel;
  height: number;
  timestamp: number;
  utcOffset: number;
}

export interface TideData {
  error: GraphDataError;
  loading: boolean;
  tideLocation?: TideLocation;
  units?: Units;
  utcOffset?: number;
  days: Array<Array<TidePoint>>;
}

export interface TideResponse {
  associated: {
    utcOffset: number;
    units: Units;
    tideLocation: TideLocation;
  };
  data: {
    tides: TidePoint[];
  };
}

export enum MoveTideLabel {
  RIGHT = 'RIGHT',
  LEFT = 'LEFT',
  NONE = 'NONE',
  BOTH = 'BOTH',
}
